import styled, { css } from "styled-components";

interface ContainerProps {
    haveData: boolean;
}

export const Container = styled.div<ContainerProps>`
    display:flex;
    height:100%;
    width:100%;
    ${props => !props.haveData && css`
        justify-content: center;
        align-items: center;
    `}
`